!function (angular) {
    "use strict";

    var serviceRequestService = angular.module('service.ServiceRequest', []);

    serviceRequestService.factory('serviceRequestCreation', [function () {

        var dto = {};

        return {
            get: function () {
                return dto;
            },
            setEvent: function (event) {
                dto.event = event;
            },
            setStation: function (station) {
                dto.station = station;
            },
            setCategory: function (category) {
                dto.category = category;
            },
            setMachine: function (machine) {
                dto.machine = machine;
            },
            setIssueDescription: function (issueDescription) {
                dto.issueDescription = issueDescription;
            },
            setProviderList: function (serviceProviders) {
                dto.serviceProviders = serviceProviders;
            },
            setNotification: function (type, phoneNumber) {
                dto.notification = {type: type, phone: phoneNumber};
            },
            setLinkedServiceRequest: function (serviceRequest) {
                dto.linkedServiceRequest = serviceRequest;
            },
            setExtendedServiceConfirmed: function (extendedServiceConfirmed) {
                dto.extendedServiceConfirmed = extendedServiceConfirmed;
            },
            setCommonFault: function (commonFault) {
                dto.commonFault = commonFault;
            },

            // When we create a service request, this serves to indicate that we have self-fixed it
            setCancelledByUser: function (cancelled) {
                dto.cancelledByUser = cancelled;
            },
            createNewDto: function () {
                dto = {};
            },

            getServiceRequestToSave: function (store) {
                var serviceRequestToSave = {
                    notificationType: dto.notification ? dto.notification.type : null,
                    notificationPhoneNumber: dto.notification ? dto.notification.phone : null,
                    extendedServiceConfirmed: (dto.extendedServiceConfirmed === undefined || dto.extendedServiceConfirmed === null || dto.extendedServiceConfirmed === '') ? false : dto.extendedServiceConfirmed,
                    cancelledByUser: dto.cancelledByUser,
                    store: {
                        id: store.id
                    },
                    providerShortList: [],
                    serviceEvent: {
                        faultDescription: dto.issueDescription,
                        commonFault: dto.commonFault,
                        machine: {
                            id: dto.machine.id
                        },
                        eventType: {
                            id: dto.event.id,
                            plannedMaintenance: dto.event.plannedMaintenance
                        }
                    }
                };

                if (dto.linkedServiceRequest) {
                    serviceRequestToSave.linkedServiceRequest = {
                        id: dto.linkedServiceRequest.id
                    }
                }

                if (dto.serviceProviders) {
                    for (var i = 0; i < dto.serviceProviders.length; i++) {
                        var provider = {
                            serviceProvider: {
                                id: dto.serviceProviders[i].id
                            }
                        };
                        serviceRequestToSave.providerShortList.push(provider);
                    }
                }

                return serviceRequestToSave;
            }
        };
    }]);

    serviceRequestService.factory('serviceRequestService', ['$http', 'halClient', 'appSettings', 'clockService', 'localStorageService', 'storageKeys', 'filterFilter', '$rootScope', 'storeService','authenticationService',
        function ($http, halClient, appSettings, clockService, localStorageService, storageKeys, filterFilter, $rootScope, storeService, authenticationService) {

            var baseUrl = appSettings.apiBaseUri + "/serviceRequest";

            var listStatusFilterUrl = baseUrl + "/query-by-statusFilter?size=14";
            var groupedListProviderUrl = appSettings.apiBaseUri + "/serviceRequestCount/query-by-serviceProviderId-grouped-by-store?size=14&serviceProviderId=";
            var countersStoreUrl = appSettings.apiBaseUri + "/serviceRequestCount/query-by-storeId?storeId=";
            var countersProviderUrl = appSettings.apiBaseUri + "/serviceRequestCount/query-by-serviceProviderId?serviceProviderId=";

            var checkOpenServiceRequestUrl = baseUrl + "/query-open-by-machineId?machineId=";
            var findByMachineUrl = baseUrl + "/query-by-machineId?machineId=";
            var createUrl = baseUrl;
            var signInUrl = appSettings.apiBaseUri + "/visit/signin";
            var signOutUrl = appSettings.apiBaseUri + "/visit/signout";
            var partSelectionUrl = appSettings.apiBaseUri + "/visit/signout-partselection";
            var machineOperationalSettingUrl = appSettings.apiBaseUri + "/visit/signout-machine-operational";

            return {
                list: function (filter) {
                    var profile = localStorageService.get(storageKeys.profileKey);

                    var listUrl = listStatusFilterUrl;
                    if (!storeService.isStoreMode()) {
                        if (parseInt(filter.store) > 0) {
                            listUrl += "&storeId=" + filter.store;
                        }
                        if(authenticationService.validateCustomStoreContextHeaderByStoreId()) {
                            return halClient.$get(listUrl + "&page=" + filter.page + "&statusFilter=" + filter.id);
                        } else {
                            var storeId = parseInt(filter.store);
                            storeService.requestStoreAuthentication(storeId).then(function (storeObj) {
                                storeService.setStoreContext(storeObj);
                                $http.defaults.headers.common['X-Context-Store'] = storeObj.storeAuthentication;
                                return halClient.$get(listUrl + "&page=" + filter.page + "&statusFilter=" + filter.id);
                            });
                        }
                    } else {
                        return halClient.$get(listUrl + "&page=" + filter.page + "&statusFilter=" + filter.id);
                    }
                },

                listGroupedByStore: function(filter){
                    var profile = localStorageService.get(storageKeys.profileKey);

                    var listUrl = groupedListProviderUrl + profile.serviceProvider;

                    return halClient.$get(listUrl +
                        "&page=" + filter.page +
                        "&statusFilter=" + filter.id +
                        "&engineerOnly=" + filter.engineerOnly);
                },

                counters: function (filter) {
                    var profile = localStorageService.get(storageKeys.profileKey);
                    var loginType = localStorageService.get(storageKeys.loginTypeKey);
                    var countersUrl = "";
                    if (loginType === 'ENGINEER') {
                        countersUrl = countersProviderUrl + profile.serviceProvider;


                    } else {
                        var store = localStorageService.get(storageKeys.storeKey);
                        countersUrl = countersStoreUrl + store.id;
                    }

                    return halClient.$get(countersUrl);
                },

                findByMachine: function (machineId) {
                    return halClient.$get(findByMachineUrl + machineId);
                },

                checkOpenServiceRequest: function (machineId, eventTypeId) {
                    return halClient.$get(checkOpenServiceRequestUrl + machineId + "&eventTypeId=" + eventTypeId);
                },

                create: function (serviceRequest) {
                    var contentType = {"Content-Type": "application/json"};
                    return halClient.$post(createUrl, contentType, serviceRequest);
                },

                signin: function (visit) {
                    var contentType = {"Content-Type": "application/json"};
                    return halClient.$post(signInUrl, contentType, visit);
                },

                signout: function (visit) {
                    var contentType = {"Content-Type": "application/json"};
                    return halClient.$put(signOutUrl, contentType, visit);
                },

                queryCostBreakDown: function (serviceRequestId, queryNote) {
                    var contentType = {"Content-Type": "application/json"};
                    var url = appSettings.apiBaseUri + "/serviceRequest/" + serviceRequestId + "/queryCostBreakdown?queryNote=" + queryNote;
                    return halClient.$put(url, contentType);
                },

                approveCostBreakDown: function (serviceRequestId) {
                    var contentType = {"Content-Type": "application/json"};
                    var url = appSettings.apiBaseUri + "/serviceRequest/" + serviceRequestId + "/approveCostBreakdown";
                    return halClient.$put(url, contentType);
                },

                resubmit: function (serviceRequest) {
                    var contentType = {"Content-Type": "application/json"};
                    var url = baseUrl + "/" + serviceRequest.id + "/resubmit";
                    return halClient.$put(url, contentType, serviceRequest);
                },

                cancel: function (serviceRequestId, cancellationReasonId, reasonDescription) {
                    var contentType = {"Content-Type": "application/json"};
                    var url = baseUrl + "/" + serviceRequestId +
                        "/cancel-with-cancellationReasonId?cancellationReasonId=" + cancellationReasonId +
                        "&reasonDescription=" + reasonDescription;
                    return halClient.$put(url, contentType);
                },

                combinedRequests: function (serviceRequestId) {
                    var url = baseUrl + "/" + serviceRequestId + "/combinedRequests";
                    return halClient.$get(url);
                },

                approveServiceRequest: function (serviceRequest) {
                    var contentType = {"Content-Type": "application/json"};
                    var url = baseUrl + "/" + serviceRequest.id + "/approveServiceRequest";
                    return halClient.$put(url, contentType, serviceRequest);
                },

                delayServiceRequest: function (serviceRequest, days) {
                    var contentType = {"Content-Type": "application/json"};
                    var url = baseUrl + "/" + serviceRequest.id + "/delay?days=" + days;
                    return halClient.$put(url, contentType, serviceRequest);
                },

                defer: function (serviceRequestId, reasonId, days) {
                    var contentType = {"Content-Type": "application/json"};
                    var url = baseUrl + "/" + serviceRequestId + "/defer?reasonId=" + reasonId + "&days=" + days;
                    return halClient.$put(url, contentType, {});
                },

                getStore: function (){

                },

                getPartSelection: function() {
                    return halClient.$get(partSelectionUrl);
                },

                isMachineOperationSetting: function() {
                    return halClient.$get(machineOperationalSettingUrl);
                }

            };
        }]);

    serviceRequestService.factory('serviceRequestSignIn', ['clockService', function (clockService) {

        var dto = {serviceActionType: "VISIT"};

        var properties = {
            changeEngineer: false,
            showSiteSpecificHazards: false,
            showHazardRating: false,
            hazardAssessmentFastSignIn: false
        };

        return {
            getMinSignInDate: function () {

                // If there was a visit already, use the latest sign-out time available
                var serviceRequest = dto.serviceRequest;

                function getNonVisitMinimumTime() {
                    // The minimum sign-in time is first time a service request could have gone to the engineer, converted to the store's local time.
                    // The only information we have is the approved time or created time for the service request.
                    if (serviceRequest.approvedTime !== null) {
                        return clockService.getTimeFromString(serviceRequest.approvedTime);
                    } else if (serviceRequest.created !== null) {
                        return clockService.getTimeFromString(serviceRequest.created);
                    }
                }

                return serviceRequest.$get("visits").then(function (results) {
                    return results.$get("visitList")
                }, getNonVisitMinimumTime).then(function (visitList) {
                    var latest_visit;
                    angular.forEach(visitList, function (visit) {
                        if (latest_visit === undefined || latest_visit.signOutTime < visit.signOutTime) {
                            latest_visit = visit;
                        }
                    });

                    if (latest_visit !== undefined && latest_visit !== null) {
                        return clockService.getTimeFromString(latest_visit.signOutTime);
                    } else {
                        return getNonVisitMinimumTime();
                    }
                }, getNonVisitMinimumTime);
            },

            get: function () {
                return dto;
            },
            getProperties: function () {
                return properties;
            },
            setServiceRequest: function (serviceRequest) {
                dto.serviceRequest = serviceRequest;
            },
            setSignInTime: function (signInTime) {
                dto.signInTime = signInTime;
            },
            setApprover: function (approver) {
                dto.approver = approver;
            },
            setSignedInBy: function (signedInBy) {
                dto.signedInBy = signedInBy;
            },
            setManager: function (manager) {
                dto.manager = manager;
            },
            setEngineer: function (engineer) {
                dto.engineer = engineer;
            },
            setHazardAssessments: function (hazardAssessments) {
                dto.hazardAssessments = hazardAssessments;
            },
            setFastSignInUsed: function(fastSignInUsed) {
              dto.fastSignInUsed = fastSignInUsed;
            },
            setHazardAssessmentFastSignIn: function(hazardAssessmentFastSignIn) {
                dto.hazardAssessmentFastSignIn = hazardAssessmentFastSignIn;
            },
            setCheckListCompleted: function (checkListCompleted) {
                dto.checkListCompleted = checkListCompleted;
            },
            setEngineerSignature: function (engineerSignature) {
                dto.engineerSignature = engineerSignature;
            },
            setManagerSignature: function (managerSignature) {
                dto.managerSignature = managerSignature;
            },
            setCombinedRequests: function (serviceRequests) {
                dto.combineRequests = serviceRequests;
            },
            setServiceActionType: function (actionType) {
                dto.serviceActionType = actionType;
            },
            createNewDto: function () {
                dto = {serviceActionType: "VISIT"};
            }
        };
    }]);

    serviceRequestService.factory('serviceRequestSignOut', ['clockService', function (clockService) {

        var dto = {
            isSample: false,
            serviceActionType: "VISIT"
        };

        return {
            getMinSignOutDate: function () {
                return dto.serviceRequest.$get("visits").then(function (results) {
                    return results.$get("visitList")
                }).then(function (visitList) {
                    var latest_visit;
                    angular.forEach(visitList, function (visit) {
                        if (latest_visit === undefined || latest_visit.signInTime < visit.signInTime) {
                            latest_visit = visit;
                        }
                    });

                    return latest_visit === undefined || latest_visit === null
                        ? null
                        : clockService.getTimeFromString(latest_visit.signInTime);
                });
            },

            get: function () {
                return dto;
            },
            getProperties: function () {
                return properties;
            },
            setServiceRequest: function (serviceRequest) {
                dto.serviceRequest = serviceRequest;
            },
            setVisitId: function (visitId) {
                dto.serviceRequest = visitId;
            },
            setSignedOutBy: function (signedOutBy) {
                dto.signedOutBy = signedOutBy;
            },
            setManager: function (manager) {
                dto.manager = manager;
            },
            setEngineer: function (engineer) {
                dto.engineer = engineer;
            },
            setStore: function(store){
                dto.store = store;
            },
            setSignOutTime: function (signOutTime) {
                dto.signOutTime = signOutTime;
            },
            setEngineerSignature: function (engineerSignature) {
                dto.engineerSignature = engineerSignature;
            },
            setManagerSignature: function (managerSignature) {
                dto.managerSignature = managerSignature;
            },
            setOutcome: function (outcome) {
                dto.outcome = outcome;
            },
            setMissingParts: function (missingParts) {
                dto.missingParts = missingParts;
            },
            setUsedParts: function (usedParts) {
                dto.usedParts = usedParts;
            },
            setScheduledVisit: function (nextVisit) {
                dto.scheduledVisit = nextVisit;
            },
            setAdditionalNotes: function (notes) {
                dto.additionalNotes = notes;
            },
            setCommonCause: function (commonCause) {
                dto.commonCause = commonCause;
            },
            setStoreSignOff: function (storeSignOff) {
                dto.storeSignOff = storeSignOff;
            },
            setEngineerSignOff: function (engineerSignOff) {
                dto.engineerSignOff = engineerSignOff;
            },
            setIsSample: function (isSample) {
                dto.isSample = isSample;
            },
            setPartsWithExtendedWarranty: function (partsWithExtendedWarranty) {
                dto.partsWithExtendedWarranty = partsWithExtendedWarranty;
            },
            setServiceActionType: function (actionType) {
                dto.serviceActionType = actionType;
            },
            createNewDto: function () {
                dto = {isSample: false, serviceActionType: "VISIT"};
            },
            reset: function () {
                dto = {};
            },
            setAvoidableCall: function (value) {
                dto.avoidableCall = value;
            },
            setMachineOperational: function (machineOperational) {
                dto.machineOperational = machineOperational;
            },
            setModelPropertyValue: function(modelPropertyValue) {
                dto.modelPropertyValue = modelPropertyValue;
            },
            setModelPropertyValues: function(modelPropertyValues) {
                dto.modelPropertyValues = modelPropertyValues;
            },
            setNoPartSelection: function(noPartSelection) {
                dto.noPartSelection = noPartSelection;
            }
        };
    }]);

    serviceRequestService.factory('serviceRequestView', ['$http', 'halClient', 'appSettings', function ($http, halClient, appSettings) {

        var addNoteUrl = appSettings.apiBaseUri + "/note/";

        var dto = {};

        return {
            get: function () {
                return dto;
            },
            setServiceRequest: function (serviceRequest) {
                dto.serviceRequest = serviceRequest;
            },
            addNote: function (note) {
                return halClient.$post(addNoteUrl, {}, note);
            }
        };
    }]);


    serviceRequestService.factory('surveyService', ['$http', 'halClient', 'appSettings',
        function ($http, halClient, appSettings) {

            var surveyUrl = appSettings.apiBaseUri + "/surveyresponse/query-by-visitId?visitId=";

            return {
                getSurvey: function (visitId) {
                    return halClient.$get(surveyUrl + visitId);
                }
            };
        }]);
}(angular);